var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrders = function SvgOrders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.191 2.667H7.81C4.77 2.667 3 4.447 3 7.497v10.33c0 3.1 1.77 4.84 4.81 4.84h8.381c3.089 0 4.809-1.74 4.809-4.84V7.497c0-3.05-1.72-4.83-4.809-4.83",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.08 7.317v.01a.78.78 0 0 0 0 1.56h2.99c.43 0 .78-.35.78-.791a.78.78 0 0 0-.78-.78zm7.84 6.09H8.08a.78.78 0 0 1 0-1.561h7.84a.781.781 0 0 1 0 1.561m0 4.57H8.08c-.3.04-.59-.11-.75-.36a.795.795 0 0 1 .75-1.21h7.84c.4.04.7.38.7.79 0 .399-.3.74-.7.78",
    clipRule: "evenodd"
  })));
};
export default SvgOrders;